import useGet from "../Hooks/useGet";
import API_ENDPOINTS from "../Config/api";
import ClipLoader from "react-spinners/ClipLoader";
import SuperficieEsternaEspostaTable from "../Components/Table/SuperficieEsternaEspostaTable";
import CredenzialiEsposteTable from "../Components/Table/CredenzialiEsposteTable";
import { useParams } from "react-router-dom";
import Tabs from "../Components/UI/Tabs";
import { useNavigate } from "react-router-dom";
import { Icon } from "../Components/UI/Icon";
import { useState, useEffect } from "react";


export default function CyberSurveillance() {

    const { id } = useParams();
    const navigate = useNavigate()

    const [cyberSurveillanceVulnerability, setCyberSurveillanceVulnerability] = useState()
    const { fetchedData: cyberSurveillanceVulnerabilityAPI } = useGet(API_ENDPOINTS.cyberSurveillanceVulnerability + `?id_monitor=${id}`);
    useEffect(() => { setCyberSurveillanceVulnerability(cyberSurveillanceVulnerabilityAPI) }, [cyberSurveillanceVulnerabilityAPI])
    console.log(cyberSurveillanceVulnerability);


    const [cyberSurveillanceStats, setCyberSurveillanceStats] = useState()
    const { fetchedData: cyberSurveillanceStatsAPI } = useGet(API_ENDPOINTS.cyberSurveillanceStats + `?id_monitor=${id}`);
    useEffect(() => { setCyberSurveillanceStats(cyberSurveillanceStatsAPI) }, [cyberSurveillanceStatsAPI])
    console.log(cyberSurveillanceStats);

    const [credenzialiEsposte, setCredenzialiEsposte] = useState()
    const { fetchedData: credenzialiEsposteAPI } = useGet(API_ENDPOINTS.listCredenzialiEsposte + `?id_monitor=${id}`);
    useEffect(() => { setCredenzialiEsposte(credenzialiEsposteAPI) }, [credenzialiEsposteAPI])
    console.log(credenzialiEsposte);

    const loader = <div className='w-full h-full flex justify-center items-center'><ClipLoader size={40} /></div>

    const tabsData = [
        {
            label: 'SUPERFICIE ESTERNA ESPOSTA',
            children: <SuperficieEsternaEspostaTable
                data={cyberSurveillanceVulnerability}
                setData={setCyberSurveillanceVulnerability}
            />,
        },
        {
            label: 'CREDENZIALI ESPOSTE',
            children: <CredenzialiEsposteTable
                data={cyberSurveillanceStats}
                setData={setCyberSurveillanceStats}
                subData={credenzialiEsposte}
                setSubData={setCredenzialiEsposte}
            />,
        },
    ];


    return (
        <div className=" p-6 items-stretch">
            <button
                onClick={() => navigate('/dashboard')}
                className="self-start flex mb-5 gap-2 items-center group text-gray-800 transition"
            >
                <Icon name="longarrowleft" />
                <span className="relative font-medium after:absolute after:left-0 after:bottom-0 after:h-[1.5px] after:w-0 after:bg-gray-800 after:transition-all after:duration-300 group-hover:after:w-full">
                    Torna alla dashboard
                </span>
            </button>


            <Tabs tabs={tabsData} />


        </div>
    )
}